import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import Details from './Details';
import ScrollMagicFn from '@/utils/ScrollMagic';

export default function River2() {
    // 这一段必须要先于子组件触发
    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
        window.AniContainer = new ScrollMagic.Controller();
    }

    return (
        <section className={`river2_h5`}>
            <Details />
        </section>
    );
}
